import { BASE_URL, STORAGE_SUF } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const getKey = async (): Promise<any> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/get-key-${suffix}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to get key`)
    }

    const data = await response.json();

    return data
  } catch (error) {
    console.error(`Error getting key`, error)
    throw error
  }
}
